import {
  createStyles, Grid,

  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import { basePath } from 'library/Routes';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        color: theme.palette.text.primary,
        padding: theme.spacing(5, 0, 0, 0),
      },
      coluna: {
        display: 'flex',
        flexDirection: 'column',
      },
      item: {
        flex: 'auto',
        margin: theme.spacing(2, 0),
      },
      itemTitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 21,
        fontWeight: 500,
        lineHeight: '25px',
      },
      itemDesc: {
        fontSize: 16,
        lineHeight: '25px',
      },
      itemPhone: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 21,
        fontWeight: 500,
        lineHeight: '30px',
        color: theme.palette.primary.main,
      },
      itemAdvice: {
        display: 'block',
        fontSize: 12,
        lineHeight: 1.2,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
      },
      qrcode: {
        maxWidth: 100,
      },
    }),
  { name: 'Footer' },
);

function Footer() {
  const classes = useStyle();
  const {t} = useTranslation();

  return (
    <footer className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={3}>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item1.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item1.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item1.phone`)}
              <Typography component="span" className={classes.itemAdvice}>
                {t(`Consulta.footer.item1.footer`)}
              </Typography>
            </Typography>
          </div>
          <img
            src={`${basePath}images/qrcode-whatsapp.png`}
            alt="QR Code WhatsApp"
            className={classes.qrcode}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.coluna}>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item2.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item2.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item2.phone`)}
              <Typography component="span" className={classes.itemAdvice}>
                {t(`Consulta.footer.item2.footer`)}
              </Typography>
            </Typography>
          </div>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item3.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item3.phone`)}
              <Typography component="span" className={classes.itemAdvice}>
                {t(`Consulta.footer.item3.footer`)}
              </Typography>
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.coluna}>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item4.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item4.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item4.phone`)}
            </Typography>
          </div>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item5.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item5.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item5.phone`)}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={3} className={classes.coluna}>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item6.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item6.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item6.phone`)}
            </Typography>
          </div>
          <div className={classes.item}>
            <Typography component="p" className={classes.itemTitle}>
              {t(`Consulta.footer.item7.title`)}
            </Typography>
            <Typography component="p" className={classes.itemDesc}>
              {t(`Consulta.footer.item7.subtitle`)}
            </Typography>
            <Typography component="p" className={classes.itemPhone}>
              {t(`Consulta.footer.item7.phone`)}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </footer>
  );
}

export default Footer;
